<template>
    <div class='main'>
        <SettingSlider pageName="dynamicMessage" />
        <div class="rightArea">
            <div class="contentArea">
                <div class="item" v-for="item in messages" :key="item.id">
                    <div class="item_type">{{item.operator}}  {{item.operateType}}</div>
                    <div class="item_title">{{item.indexPointRequire}}</div>
                    <div class="item_time">{{item.createTime}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import SettingSlider from "../../components/SettingSlider.vue";
    // import server from '../../server';
    export default {
        name: 'selfInfo',
        components: {
            "SettingSlider": SettingSlider,
        },
        data() {
            return {
                messages: [{
                        id: "1",
                        operator: "评审员",
                        operateType: "驳回",
                        indexPointID: "1",
                        indexPointRequire: "党委要把市域社会治理列入党委重要议程",
                        createTime: '2021.05.22  15:30'
                    },
                    {
                        id: "2",
                        operator: "评审员",
                        operateType: "驳回",
                        indexPointID: "2",
                        indexPointRequire: "党委要把市域社会治理列入党委重要议程",
                        createTime: '2021.05.22  15:30'
                    },
                    {
                        id: "3",
                        operator: "评审员",
                        operateType: "驳回",
                        indexPointID: "3",
                        indexPointRequire: "党委要把市域社会治理列入党委重要议程",
                        createTime: '2021.05.22  15:30'
                    }
                ],
            };
        },
        mounted() {},
        methods: {
            goProjectDetails() {
                this.$router.push('/project/taskList');
            }
        },
    };
</script>
<style scoped lang="less">
    .rightArea {
        background-color: #F6F9FC;
        height: (1080 - 96)px;
        border-top: 1px #F6F9FC solid;

        .contentArea {
            height: 930px;
            margin-left: 325px;
            margin-right: 58px;
            margin-top: 48px;
            overflow: auto;
            
            .item {
                background-color: white;
                height: 76px;
                margin-top: 10px;
                margin-left: 20px;
                border-radius: 5px;
                
                .item_type {
                    float: left;
                    margin-top: 28px;
                    margin-left: 50px;
                    color: #464E58;
                    font-family: 'Source Han Sans CN';
                    font-weight: 400;
                    font-size: 20px;
                }
                
                .item_title {
                    padding-top: 28px;
                    padding-left: 200px;
                    color: #4265ED;
                    font-family: 'Source Han Sans CN';
                    font-weight: 400;
                    font-size: 20px;
                }
                
                .item_time {
                    float: right;
                    margin-top: -30px;
                    margin-right: 30px;
                    color: #666666;
                    font-family: 'Source Han Sans CN';
                    font-weight: 400;
                    font-size: 20px;
                }
            }
        }
    }
</style>
